import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { useErrorState } from '@/client/components/_hooks/useErrorState'
import { extractFileName } from '@/client/utils/string'

interface Props {
  pictureUrl: string | null
  size?: number
}


const DEFAULT_SIZE = 40 // Vue 2.7 の defineProps 巻き上げエラーを回避するため、モジュールスコープで定義

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmAvatar',
  props: {
    pictureUrl: null,
    size: { default: DEFAULT_SIZE }
  },
  setup(__props: any) {

const props = __props as { pictureUrl: string | null, size: number };


const { hasError, onError } = useErrorState()
const fileName = computed(() => extractFileName(props.pictureUrl ?? ''))

return { __sfc: true,DEFAULT_SIZE, props, hasError, onError, fileName }
}

})